import { render } from "./EventButton.vue?vue&type=template&id=64d02cf7"
import script from "./EventButton.vue?vue&type=script&lang=js"
export * from "./EventButton.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__